import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'

import { Select, FormElement } from 'mailup-web-components'

import { abTestState, dynamicOptionsState } from '../../../recoil/state/abtest'

const DynamicSenderEmail = () => {
  const intl = useIntl()
  const [{ step2 }, setAbTestState] = useRecoilState(abTestState)
  const dynamicOptions = useRecoilValue(dynamicOptionsState)

  const handleChange = e => {
    const selectedOption = dynamicOptions.find(f => f.value === e)

    setAbTestState(prev => ({
      ...prev,
      step2: {
        ...prev.step2,
        step2IsDirty: true,
        senderInfo: {
          ...prev.step2.senderInfo,
          customEmailValue: selectedOption ? selectedOption.value : undefined,
          customEmailLabel: selectedOption ? selectedOption.label : undefined,
          customEmailValueIsDirty: true
        }
      }
    }))
  }

  return (
    <div>
      <FormElement
        required
        label={intl.formatMessage({
          id: 'Load.EmailSendingWizard.CustomSenderEmailLabel'
        })}
        feedback={
          (step2.senderInfo.customEmailValue === undefined ||
            step2.senderInfo.customEmailValue <= 0) &&
          step2.senderInfo.customEmailValueIsDirty
            ? intl.formatMessage({
                id: 'Load.EmailSendingWizard.SenderNameRequired'
              })
            : undefined
        }
      >
        <Select
          value={step2.senderInfo.customEmailValue}
          onChange={handleChange}
          placeholder={intl.formatMessage({
            id: 'Load.Filters.IdentifierPlaceholder'
          })}
          options={dynamicOptions}
          error={
            (step2.senderInfo.customEmailValue === undefined ||
              step2.senderInfo.customEmailValue <= 0) &&
            step2.senderInfo.customEmailValueIsDirty
          }
        />
      </FormElement>
    </div>
  )
}

export default DynamicSenderEmail
